export default "__VITE_ASSET__4Pj_4TR6__"